export const CHECK_INTERVAL_MS = 2 * 60 * 60 * 1000;
export const FORCE_UPDATE_AFTER_MS = 12 * 60 * 60 * 1000;
